import Vue from 'vue';
import axios from './axios';
import store from '../store';
import utils from './utils';
import validator from './validator_extend';
import toast from '../components/toast.vue';
import confirm from '../components/confirm.vue';
import preview from '../components/preview.vue';

export default {
  /**
   * 提示信息
   * @param opt{object/string} 提示信息内容(message)及位置(position)
   * @example
   this.$toast({ message: '消息提示', position: 'top', });
   */
  toast: function (opt) {
    if (typeof opt === 'string') {
      opt = { message: opt, position: '' };
    }
    const ToastBox = Vue.extend(toast);
    const toastBoxComponents = new ToastBox({ data: opt }).$mount();
    document.getElementById('app').appendChild(toastBoxComponents.$el);
  },
  /**
   * 确认选择弹窗
   * @param opt {object/string} 提示信息内容{type(类型input/alert/默认) title(标题)，content(内容)}
   * @param cb {function} 选择确定后的回调包含三个参数（data[boolean]:确定/取消, done[function] 关闭弹窗方法，value[String]输入值）
   * @example
   this.$confirm( '确定删除吗？', (data, done) => { if(data){ done(); alert('成功！')} });
   */
  confirm: function (opt, cb) {
    if (typeof opt === 'string') {
      opt = { type: '', title: '提示', content: opt };
    }
    cb = cb || function () {};
    const ConfirmBox = Vue.extend(confirm);
    const confirmBoxComponents = new ConfirmBox({
      data() {
        return {
          show: false,
          value: '',
          option: {
            type: opt.type,
            title: opt.title,
            content: opt.content,
            placeholder: opt.placeholder,
          },
        };
      },
      methods: {
        cancel() {
          cb(false, this.done, this.value);
        },
        ok() {
          cb(true, this.done, this.value);
        },
      },
    }).$mount();
    document.getElementById('app').appendChild(confirmBoxComponents.$el);
  },
  /**
   *  GET请求加载数据
   * @param url {String} ajax请求地址
   * @param data {Function} ajax请求提交的数据
   * @param isLoading {Boolean} 是否显示加载动画
   * @example
       const result = await this.$getJSON('/login');
       if(result.errcode){ this.$toast(data.errmsg); return;};
       alert('登录成功');
   */
  getJSON: async function (url, data, isLoading) {
    try {
      if (typeof data === 'boolean') {
        isLoading = data;
        data = {};
      }
      if (isLoading) store.commit('ISLOADING', true);
      const result = await axios.get(url, { params: data });
      if (isLoading) store.commit('ISLOADING', false);
      return result.data;
    } catch (err) {
      if (isLoading) store.commit('ISLOADING', false);
      return {};
    }
  },
  /**
   * POST请求加载数据
   * @param url {String} ajax请求地址
   * @param data {Function} ajax请求提交的数据
   * @param isLoading {Boolean} 是否显示加载动画
   * @example
       const result = await this.$postJSON('/login');
       if(result.errcode){ this.$toast(data.errmsg); return;};
       alert('登录成功');
   */
  postJSON: async function (url, data, isLoading) {
    try {
      if (typeof data === 'boolean') {
        isLoading = data;
        data = {};
      }
      if (isLoading) store.commit('ISLOADING', true);
      const result = await axios.post(url, data);
      if (isLoading) store.commit('ISLOADING', false);
      return result.data;
    } catch (err) {
      if (isLoading) store.commit('ISLOADING', false);
      return {};
    }
  },
  /**
   * 深度拷贝
   * @param data{object} 数据对象
   * @example
   const data = this.$getFormatData(this.form);
   */
  getFormatData: function (data) {
    return JSON.parse(JSON.stringify(data));
    // 或者return Object.assign({}, data)
  },
  /**
   * 获取对象内指定的字段并赋值
   * @param todata{object} 需要赋值的对象
   * @param data{object} 数据对象（数据源）
   * @param str{String} 赋值的字段名用多个用逗号隔开(没有该参数时，默认为todata的属性集合)
   * @example
   * this.$setFormatData(this.syncForm, data.retobj, 'brandName,originPlace,manufactorID');
   */
  setFormatData: (todata, data, str) => {
    if (typeof str === 'string') {
      const keys = str.split(',');
      keys.forEach((t) => {
        todata[t] = typeof data[t] === 'undefined' ? null : data[t];
      });
      return;
    }
    const propertys = Object.getOwnPropertyNames(todata);
    propertys.forEach((t) => {
      todata[t] = typeof data[t] === 'undefined' ? null : data[t];
    });
  },
  /**
   * 倒计时
   * @param num{Number} 初始数字
   * @param cb{Function} 初始数字
   * @example
   this.$countdown(60, (data)=> {
         console.log(data);
       })
   */
  countdown: function (num, cb) {
    cb(num);
    const IntervalName = setInterval(() => {
      num--;
      if (!num) {
        clearInterval(IntervalName);
      }
      cb(num);
    }, 1000);
  },
  /**
   * 滑动穿透解决方案
   * 滑动穿透解决方案,方法依赖样式body.modal-open{position:fixed;left: 0;width:100%;}
   * @param type {String} 默认开启body禁止滚动，参数为close是解除禁止
   * @example
   onOpenDialog: function () {
       this.$fixedBody();
     }
   onCloseDialog: function (){
       this.$fixedBody('close');
     }
   */
  fixedBody: function (isFixed) {
    if (isFixed) {
      const scrollTop = document.scrollingElement.scrollTop;
      document.body.setAttribute('class', 'modal-open');
      document.body.style.top = `-${scrollTop}px`;
      document.body.setAttribute('scroll', scrollTop);
      return;
    }
    const scrollTop = document.body.getAttribute('scroll') || 0;
    document.body.removeAttribute('class');
    document.scrollingElement.scrollTop = scrollTop;
  },
  /**
   * 上传七牛图片
   * @param fileList {array} 图片文件对象数组（每个对象为event.target.files[0]; event为input的上传事件change）
   * @param prefix {string} 上传图片命名前缀
   * @param token {String} 提交七牛的koten值
   * @param cb {function} 图片全部提交七牛后的回调
   * @example  <input accept="image/*" type="file" @change="uploadFile($event)"/>
   uploadFile:function(event) {
        const targetFile = event.target.files[0];
        targetFile.base64 = window.URL.createObjectURL(targetFile); // 将本地预览地址绑定到base64属性上
        this.uploadQueue.push(targetFile);
     },
   submitFile: function (){
         this.$uploadQiniu(this.uploadQueue, goods, this.qiniuToken, (data)=>{
           if(data.errcode) return this.$toast(data.errmsg);
           console.log(data.flieList);
         })
     },
   */
  uploadQiniu: function (fileList, prefix, token, cb) {
    if (fileList.length === 0) {
      cb({ errcode: 1, flieList: [], errmsg: '图片不存在' });
      return;
    }
    const uploadedFileList = new Array([fileList.length]);
    let uploadedCount = 0;
    for (const [index, item] of fileList.entries()) {
      utils.imageZipped(item, (rst) => {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        const keyName = `${prefix}-${utils.randomDateNum()}.jpg`;
        const formData = new FormData();
        formData.append('token', token);
        formData.append('key', keyName);
        formData.append('file', rst.file);
        this.$http.post('https://upload.qiniup.com', formData, config)
          .then((res) => {
            if (res.data.hash && res.data.key) {
              uploadedFileList[index] = res.data.key;
              uploadedCount++;
            }
            if (fileList.length === uploadedCount) {
              cb({ errcode: 0, errmsg: '图片上传成功', flieList: uploadedFileList });
            }
          })
          .catch((err) => {
            cb({ errcode: 1, errmsg: '图片上传失败', flieList: [] });
            console.error(err);
          });
      });
    }
  },
  /**
   * 表单验证
   * @param requestData{object} 需要请求的数据对象
   * @param models{object} 验证规则模型：{title:属性名，required：是否必填，rule:[{name: 规则名，opt: 规则方法参数，msg：提示}]}
   * @return {array} 返回验证失败的对象数组：[{ field: 'username', errmsg: '用户名不能为空' }]
   * @example
   const result = this.$checkData(this.form, {
    username: { title: '用户名', required: true, rule: [{ name: 'isIntFormat', opt: { min: 6 }, msg: '不能大于6个字符' }] },
    password: { title: '密码', required: true },
  })
   if (result.length > 0) {
    this.$toast(result[0].errmsg);
    return;
  }
   */
  checkData: function (requestData, models) {
    let errModels = [];
    // 检测必填项(required为true时，提交对象是null、undefined,空字符串时，则返回错误结果)
    const propertys = Object.getOwnPropertyNames(models); // 全部需要验证的属性数组
    const requirePropertyList = propertys.filter(f => models[f].required && validator.isNullOrEmpty(requestData[f]));
    if (requirePropertyList.length > 0) {
      errModels = requirePropertyList.map(t => ({ field: t, errmsg: `${models[t].title}不能为空` }));
    }
    // 验证rule规则检测数据准确性
    let rulePropertyList = propertys.filter(f => (models[f].rule || []).length > 0); // 含有规则的验证属性数组
    rulePropertyList = rulePropertyList.filter(t => !requirePropertyList.includes(t)); // 过滤掉报不能为空的项
    rulePropertyList.forEach((f) => {
      const ruleList = models[f].rule.filter(t => !validator[t.name](`${requestData[f]}`, t.opt)); // 某一属相不满足的规则数组
      // 存在错误时
      if (ruleList.length > 0) {
        const msgList = ruleList.map(t => t.msg).join(',且');
        const errRuleModels = { field: f, errmsg: `${models[f].title}${msgList}` };
        errModels.push(errRuleModels);
      }
    });
    return errModels;
  },

  /**
   * 预览图片
   * @param imageUrl {String} 预览图片地址
   * @example
   <img @click='$previewImage('img.baidu.com/logo.png')' src='img.baidu.com/logo.png'/>
   */
  previewImage: function (imageUrl) {
    const MessageBox = Vue.extend(preview);
    const msgBoxComponents = new MessageBox({
      data: {
        imageUrl: imageUrl,
      },
    }).$mount();
    document.getElementById('app').appendChild(msgBoxComponents.$el);
  },
  /**
   * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
   * 即 百度 转 谷歌、高德
   * @param bd_lon
   * @param bd_lat
   * @returns {*[]}
   */
  bd09togcj02 : function (bd_lon, bd_lat) {
      var x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      var x = bd_lon - 0.0065;
      var y = bd_lat - 0.006;
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      var gg_lng = z * Math.cos(theta);
      var gg_lat = z * Math.sin(theta);
      return [gg_lng, gg_lat]
  },
  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param lng
   * @param lat
   * @returns {*[]}
   */
  gcj02tobd09 : function (lng, lat) {
	  var x_PI = 3.14159265358979324 * 3000.0 / 180.0;
      var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
      var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
      var bd_lng = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lng, bd_lat]
  }
};



// WEBPACK FOOTER //
// ./src/config/common.js